import api, { apiWrapper } from '../api/axios';

export const getDrivers = async ({
  status = 'all',
  driver_type = '',
  search = null,
  branch = 0,
  page = 1,
  pageSize = 20,
  paginate = true
}) => {
  let params = {
    status,
    driver_type,
    page,
    branch,
    page_size: pageSize,
    paginate
  };
  if (search != null) {
    params = { ...params, search };
  }
  return apiWrapper(() => api.get(`/driver/`, { params }));
};

export const createDriver = async (data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.post("/driver/", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateDriver = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.put(`/driver/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateDriverPartial = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.patch(`/driver/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const toggleDriverStatus = async (id, isActive) => {
  return apiWrapper(() => api.patch(`/driver/${id}/${isActive ? 'activate' : 'deactivate'}/`));
};

export const downloadDriverDoc = async (id, doc_type) => {
  return apiWrapper(() => api.get(`/driver/${id}/download/${doc_type}/`));
};

export const getDriverDailyAttendance = async (driver_ids = [], date) => {
  const ids = Array.isArray(driver_ids) ? driver_ids : [driver_ids];
  const params = { date };
  if (ids.length > 0) {
    params.driver_ids = ids.join(',');
  }
  return apiWrapper(() => api.get('/driver/attendance/view-daily/', { params }));
};

export const getDriverDailyAttendanceSessions = async (driver, date) => {
  const params = { driver, date };
  return apiWrapper(() => api.get('/driver/attendance/view-all-daily/', { params }));
};

export const getDriverMonthlyAttendance = async (driver_ids = [], month, year) => {
  const ids = Array.isArray(driver_ids) ? driver_ids : [driver_ids];
  const params = { month, year };
  if (ids.length > 0) {
    params.driver_ids = ids.join(',');
  }
  return apiWrapper(() => api.get('/driver/attendance/view-monthly-consolidated/', { params }));
};

export const exportDriverMonthlyAttendance = async ({
  month,
  year,
  driver_ids = [],
  format = 'xlsx',
}) => {
  const ids = Array.isArray(driver_ids) ? driver_ids : [driver_ids];
  const params = {
    month,
    year,
    file_format: format,
    driver_ids: ids.join(','),
  };
  return apiWrapper(() => api.get('/driver/attendance/export-monthly/', { params, responseType: 'blob' }), true, false, true);
};

export const markAttendance = async (driver_id, date, attendance_type = 'present', driver_ids = []) => {
  const params = { driver_id, date, attendance_type };
  if (Array.isArray(driver_ids) && driver_ids.length > 0) {
    params.driver_ids = driver_ids.join(',');
  }
  return apiWrapper(() => api.post('/driver/attendance/mark-attendance/', params));
};

const extract_id = (value) => {
  // If value is an object (e.g. a nested serializer response), extract its id.
  // Otherwise return the value as-is (already a primitive id).
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    return value.id;
  }
  return value;
};

const construct_form_data = (data) => {

  let form = new FormData();

  // Add text fields
  form = add_field(form, 'name', data?.name);
  form = add_field(form, 'primary_phone', data?.primary_phone);
  form = add_field(form, 'secondary_phone', data?.secondary_phone);
  form = add_field(form, 'email', data?.email);
  form = add_field(form, 'password', data?.password);
  form = add_field(form, 'driver_type', data?.driver_type);
  form = add_field(form, 'branch_id', extract_id(data?.branch_id) || extract_id(data?.branch));
  form = add_field(form, 'joining_date', data?.joining_date);
  form = add_field(form, 'relieving_date', data?.relieving_date);
  form = add_field(form, 'salary', data?.salary);
  form = add_field(form, 'aadhar_number', data?.aadhar_number);
  form = add_field(form, 'licence_number', data?.licence_number);
  form = add_field(form, 'licence_expiry', data?.licence_expiry);
  form = add_field(form, 'pan_number', data?.pan_number);
  form = add_field(form, 'is_active', data?.is_active ? 1 : 0);

  // Add file fields (make sure these are actual File objects from input type="file")
  form = add_field(form, 'aadhar_doc', data?.aadhar_doc);
  form = add_field(form, 'licence_doc', data?.licence_doc);
  form = add_field(form, 'pan_doc', data?.pan_doc);
  form = add_field(form, 'photo_doc', data?.photo_doc);

  return form;
};

const add_field = (form, key, value) => {
  if (value !== undefined) {
    form.append(key, value);
  }
  return form;
};

export const resetPassword = async (id, data) => {
  return apiWrapper(() => api.patch(`/driver/${id}/reset-password/`, data));
};
